// components/StudentDetailsModal.jsx
import React from "react";
import { Modal, Button, Tab, Nav } from "react-bootstrap";

const StudentDetailsModal = ({ show, handleClose, studentData = {} }) => {
  const getValue = (key, defaultVal = "") => studentData[key] || defaultVal;
  const divyangURL = getValue("divyanG_CERTIFICATE_URL");
  const isValid = (v) =>
    v !== undefined &&
    v !== null &&
    v !== "" &&
    v !== "null" &&
    !(typeof v === "string" && v.trim() === "");

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        centered
        backdrop="static"
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Student Full Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tab.Container
            defaultActiveKey={
              studentData.prinT_CATEGORY === "EX-REGULAR" ? "docs" : "info"
            }
          >
            <Nav variant="tabs">
              {studentData.prinT_CATEGORY === "EX-REGULAR" ? null : (
                <Nav.Item>
                  <Nav.Link eventKey="info">Student Information</Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item>
                <Nav.Link eventKey="docs">Documentation</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content className="pt-3">
              {/* ===== Student Info Tab ===== */}
              {studentData.prinT_CATEGORY === "EX-REGULAR" ? (
                ""
              ) : (
                <Tab.Pane eventKey="info">
                  <h6 className="mb-2">Student Details</h6>
                  <div className="row">
                    <InfoItem
                      label="Name of Student"
                      value={getValue("candidatE_NAME")}
                      col="4"
                    />
                    <InfoItem
                      label="Gender"
                      value={getValue("gender")}
                      col="2"
                    />
                    <InfoItem
                      label="Date of Birth"
                      value={getValue("dob")}
                      col="3"
                    />
                    <InfoItem
                      label="Divyang"
                      value={getValue("divyanG_NAME")}
                      col="3"
                    />
                    <InfoItem
                      label="Father's Name"
                      value={getValue("fatheR_NAME")}
                      col="6"
                    />
                    <InfoItem
                      label="Mother's Name"
                      value={getValue("motheR_NAME")}
                      col="6"
                    />
                    <InfoItem
                      label="Caste"
                      value={getValue("castE_NAME")}
                      col="3"
                    />
                    <InfoItem
                      label="Religion"
                      value={getValue("religioN_NAME")}
                      col="3"
                    />
                    <InfoItem
                      label="Nationality"
                      value={getValue("nationality")}
                      col="3"
                    />
                    <InfoItem
                      label="Student Aadhaar No"
                      value={getValue("aadhaR_CARD")}
                      col="3"
                    />
                  </div>

                  <h6 className="mt-4 mb-2">Permanent Address</h6>
                  <div className="row">
                    <InfoItem label="Area" value={getValue("area")} col="3" />
                    <InfoItem label="State" value={getValue("state")} col="3" />
                    <InfoItem
                      label="District"
                      value={getValue("district")}
                      col="3"
                    />
                    <InfoItem
                      label="Block"
                      value={getValue("blocK_NAME")}
                      col="3"
                    />
                    <InfoItem
                      label="Contact No."
                      value={getValue("contacT_NO")}
                      col="6"
                    />
                    <InfoItem
                      label="Email ID"
                      value={getValue("emaiL_ID")}
                      col="6"
                    />
                    <InfoItem
                      label="Address"
                      value={getValue("address")}
                      col="6"
                    />
                    <InfoItem
                      label="Pin Code"
                      value={getValue("pincode")}
                      col="6"
                    />
                  </div>

                  <h6 className="mt-4 mb-2">Educational Details</h6>
                  <div className="row">
                    <InfoItem
                      label="Category"
                      value={getValue("prinT_CATEGORY")}
                      col="3"
                    />
                    <InfoItem
                      label="Board"
                      value={getValue("boarD_NAME")}
                      col="3"
                    />
                    <InfoItem
                      label="Medium"
                      value={getValue("mediuM_NAME")}
                      col="3"
                    />
                    <InfoItem
                      label="Compulsory I"
                      value={getValue("subjecT_1")}
                      col="3"
                    />
                    <InfoItem
                      label="Language I"
                      value={getValue("subjecT_2")}
                      col="3"
                    />
                    <InfoItem
                      label="Language II"
                      value={getValue("subjecT_3")}
                      col="3"
                    />
                    <InfoItem
                      label="Compulsory II"
                      value={getValue("subjecT_4")}
                      col="3"
                    />
                    <InfoItem
                      label="Compulsory III"
                      value={getValue("subjecT_5")}
                      col="3"
                    />
                    <InfoItem
                      label="Additional Subject"
                      value={getValue("subjecT_6")}
                      col="3"
                    />
                  </div>

                  <h6 className="mt-4 mb-2">Other Details</h6>
                  <div className="row">
                    <InfoItem
                      label="PEN No."
                      value={getValue("peN_NO") || ""}
                      col="3"
                    />
                    <InfoItem
                      label="APAAR ID"
                      value={getValue("apaaR_ID")}
                      col="3"
                    />
                    <InfoItem
                      label="Section"
                      value={getValue("section")}
                      col="3"
                    />
                    <InfoItem
                      label="Class Roll No."
                      value={getValue("clasS_ROLL_NO")}
                      col="3"
                    />
                  </div>
                </Tab.Pane>
              )}
              {/* ===== Documents Tab ===== */}
              <Tab.Pane eventKey="docs">
                <div className="card shadow-sm border-0">
                  <div className="card-header bg-primary text-white fw-semibold">
                    Uploaded Documents
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Document Name</th>
                          <th>File Details</th>
                          {/* <th>Attachment Type</th> */}
                          <th>Preview</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Photograph row, only if not null/empty */}
                        {getValue("studenT_PHOTOGRAPH") && (
                          <DocRow
                            label="Photograph"
                            type={getValue("studenT_PHOTOGRAPH")}
                            format="JPG"
                            size="28 KB"
                            src={getValue("studenT_PHOTOGRAPH_URL")}
                            height="100px"
                            width="100px"
                          />
                        )}

                        {/* Signature row, only if not null/empty */}
                        {getValue("studenT_SIGNATURE") && (
                          <DocRow
                            label="Signature"
                            type={getValue("studenT_SIGNATURE")}
                            format="JPG"
                            size="15 KB"
                            src={getValue("studenT_SIGNATURE_URL")}
                            height="60px"
                            width="150px"
                          />
                        )}

                        {/* Divyang Certificate row */}
                        {getValue("divyanG_CERTIFICATE")?.trim() &&
                          getValue("divyanG_CERTIFICATE_URL")?.trim() && (
                            <DocRow
                              label="Divyang Certificate"
                              type={getValue("divyanG_CERTIFICATE")}
                              format="PDF"
                              size="28 KB"
                              src={getValue("divyanG_CERTIFICATE_URL")}
                            />
                          )}

                        {/* Caste Certificate row */}
                        {getValue("castE_CERTIFICATE")?.trim() &&
                          getValue("castE_CERTIFICATE_URL")?.trim() && (
                            <DocRow
                              label="Caste Certificate"
                              type={getValue("castE_CERTIFICATE")}
                              format="PDF"
                              size="28 KB"
                              src={getValue("castE_CERTIFICATE_URL")}
                            />
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const InfoItem = ({ label, value, col = "3" }) => (
  <div className={`col-md-${col} mb-2`}>
    <label className="form-label">{label}</label>
    <input className="form-control form-control-sm" disabled value={value} />
  </div>
);

const DocRow = ({ type, format, size, src, label, height, width }) => {
  // If no file provided, render nothing.
  if (!src || !type) return null;

  const isPDF = src?.toLowerCase().includes(".pdf");

  return (
    <tr>
      <td>
        <strong>{label}</strong>
      </td>
      <td className="text-muted small">
        <strong>Format:</strong> {format}
        <br />
        <strong>Size:</strong> {size}
      </td>
      {/* <td>
        <strong className="d-flex align-items-center gap-2">
          {isPDF ? (
            <i className="fa fa-file-pdf text-danger"></i>
          ) : (
            <i className="fa fa-file text-primary"></i>
          )}
          {format}
        </strong>
      </td> */}
      <td>
        {isPDF ? (
          <div className="mb-3 d-flex align-items-center gap-3 flex-wrap">
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className="text-info"
              style={{ transition: "transform 0.3s ease" }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.15)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              {/* <i className="fa-solid fa-file-pdf fa-2x text-primary"></i> */}
            </a>
            <a
              href={src}
              download
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm d-flex align-items-center gap-2 text-white btn-primary"
              title={`Download ${type}`}
            >
              <i className="fa fa-download"></i>
              <span className="d-none d-sm-inline">Download</span>
            </a>
          </div>
        ) : (
          src && (
            <img
              src={src || "/default-student.png"}
              alt={type}
              className="img-thumbnail"
              style={{
                height: height,
                width: width,
              }}
            />
          )
        )}
      </td>
    </tr>
  );
};

export default StudentDetailsModal;
